<template>
  <div :class="{'ima-sign-editor-panel' : true, 'ima-sign-editor-panel--expanded' : isExpanded}">

    <button class="button ima-sign-editor-panel__toggle-btn" @click="onToggle()">
      <b-icon v-if="isExpanded" icon="chevron_right"></b-icon>
      <b-icon v-if="!isExpanded" icon="chevron_left"></b-icon>
    </button>

    <b-tabs v-if="isExpanded" :animated="false">

      <b-tab-item label="Text" icon="title">
        <div v-for="label in labels.data" :key="label.index" class="ima-sign-editor-panel__label" v-if="!label.isSlogan && !label.isStamp">
          <label class="label">{{label.description || label.placeholder || label.name}}</label>
          <p class="control">
            <ima-autosize-textarea :placeholder="label.placeholder" :value="label.value" @input="(value)=>{onLabelChange(label, value)}" />
          </p>
        </div>
      </b-tab-item>

      <b-tab-item label="Slogan" icon="textsms" v-if="svg.hasSloganField">
        <b-field label="Slogan">
          <b-select expanded placeholder="Auswählen" :value="variant.data.slogan ? variant.data.slogan.id : null" @input="onSloganChange">
            <option v-for="slogan in slogans.data" :key="slogan.text" :value="slogan.id">{{truncate(slogan.text, 36)}}</option>
          </b-select>
        </b-field>

      <b-input type="textarea" v-if="variant.data.slogan && variant.data.slogan.text" readonly disabled :value="variant.data.slogan.text"></b-input>

      </b-tab-item>

      <b-tab-item label="ERP" icon="subtitles" v-if="svg.hasArrowBox">

      <fieldset>
        <legend>Erstes Logo</legend>
        <b-field label="Pfeil">
          <b-select expanded placeholder="Auswählen" :value="firstArrow" @input="(value)=>onArrowChange(0, value)">
            <option :value="null">Kein Logo</option>
            <optgroup v-for="group in arrows.data" :key="group.group" :label="group.group">
              <option v-for="arrow in group.arrows" :key="arrow.label" :value="arrow.value">{{group.group}} - {{arrow.label}}</option>
            </optgroup>
          </b-select>
        </b-field>

        <b-field label="Spektrum" v-if="!isSystem">
          <b-select  expanded placeholder="Auswählen" :value="firstSpectrum" @input="(value)=>onArrowSpectrumChange(0, value)">
            <option :value="null">Kein Spektrum</option>
            <option v-for="spectrum in arrowSpectrums.data.nonSystem" :key="spectrum.value" :value="spectrum.value">{{spectrum.label}}</option>
          </b-select>
        </b-field>
        <b-field label="Spektrum" v-if="isSystem">
          <b-input expanded type="input" readonly disabled :value="arrowSpectrums.data.system[0].label"></b-input>
        </b-field>

      </fieldset>


      <fieldset>
        <legend>Zweites Logo</legend>
        <b-field label="Pfeil">
          <b-select expanded placeholder="Auswählen" :value="secondArrow" @input="(value)=>onArrowChange(1, value)">
            <option :value="null">Kein Logo</option>
            <optgroup v-for="group in arrows.data" :key="group.group" :label="group.group">
              <option v-for="arrow in group.arrows" :key="arrow.label" :value="arrow.value">{{group.group}} - {{arrow.label}}</option>
            </optgroup>
          </b-select>
        </b-field>

        <b-field label="Spektrum" v-if="!isSystem">
          <b-select  expanded placeholder="Auswählen" :value="secondSpectrum" @input="(value)=>onArrowSpectrumChange(1, value)">
            <option :value="null">Kein Spektrum</option>
            <option v-for="spectrum in arrowSpectrums.data.nonSystem" :key="spectrum.value" :value="spectrum.value">{{spectrum.label}}</option>
          </b-select>
        </b-field>
        <b-field label="Spektrum" v-if="isSystem">
          <b-input expanded type="input" readonly disabled :value="arrowSpectrums.data.system[0].label"></b-input>
        </b-field>
      </fieldset>

        <div class="field">
          <b-checkbox :value="isSystem" @input="onSystemToggle">Darstellung als System</b-checkbox>
        </div>

      </b-tab-item>

    </b-tabs>

  </div>
</template>


<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { fetchArrows } from '@/store/modules/arrows'
import { fetchSlogans } from '@/store/modules/slogans'
import { updateLabel, saveLabels } from '@/store/modules/labels'
import { updateSlogan, saveVariant } from '@/store/modules/variant'
import { updateSign, saveSign, addArrow, addArrowSpectrum } from '@/store/modules/sign'
import AutoSizeTextArea from '@/components/AutoSizeTextArea'

export default {
  name: 'ima-sign-editor-panel',
  components: {
    'ima-autosize-textarea': AutoSizeTextArea
  },
  data () {
    return {
      firstArrow: null,
      firstSpectrum: null,
      secondArrow: null,
      secondSpectrum: null,
      isExpanded: true
    }
  },
  computed: {
    ...mapState(['labels', 'arrows', 'arrowSpectrums', 'sign', 'slogans', 'variant', 'svg']),
    isSystem () {
      return this.sign.data && this.sign.data.isSystem
    }
  },
  filters: {},
  methods: {
    ...mapActions([
      fetchArrows,
      fetchSlogans,
      saveSign,
      saveVariant,
      saveLabels
    ]),
    ...mapMutations([updateLabel, updateSign, addArrow, addArrowSpectrum, updateSlogan]),
    onLabelChange (label, value) {
      const { name } = label
      this.updateLabel({ name, value })
      this.saveLabels()
    },
    onSloganChange (value) {
      const slogan = this.slogans.data.find(({ id }) => id === value)
      this.updateSlogan(slogan)
      this.saveVariant(this.variant.data)
    },
    onArrowChange (index, value) {
      if (this.sign.data.arrows[index] === value) {
        return
      }
      this.addArrow({ index, value })
      this.saveSign(this.sign.data)
    },
    onArrowSpectrumChange (index, value) {
      if (this.sign.data.arrowSpectrum[index] === value) {
        return
      }
      this.addArrowSpectrum({ index, value })
      this.saveSign(this.sign.data)
    },
    onSystemToggle (value) {
      this.updateSign({ isSystem: value })
      this.saveSign(this.sign.data)
    },
    onToggle () {
      this.isExpanded = !this.isExpanded
    },
    truncate: (string, value) => {
      if (string.length > value) {
        return string.substring(0, value) + '...'
      }
      return string
    }
  },
  mounted () {
    Promise.all([this.fetchArrows(), this.fetchSlogans()]).then(() => {
      const all = this.arrows.data.reduce(
        (all, group) => [...all, ...group.arrows],
        []
      )
      if (this.sign.data.arrows) {
        this.firstArrow =
          this.sign.data.arrows[0] &&
          all.find(arrow => arrow.value === this.sign.data.arrows[0]).value

        if (this.sign.data.arrowSpectrum && this.sign.data.arrowSpectrum[0]) {
          this.firstSpectrum = this.sign.data.arrowSpectrum[0]
        }

        if (this.sign.data.arrows.length > 1) {
          this.secondArrow =
            this.sign.data.arrows[1] &&
            all.find(arrow => arrow.value === this.sign.data.arrows[1]).value

          if (this.sign.data.arrowSpectrum && this.sign.data.arrowSpectrum[1]) {
            this.secondSpectrum = this.sign.data.arrowSpectrum[1]
          }
        }
      }
    })
  }
}
</script>


<style lang="scss">
@import '../scss/settings';

.ima-sign-editor-panel {
  filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));
  margin-left: 1rem;

  &--expanded {
    min-width: 25rem;
    width: auto;
  }

  &__toggle-btn {
    position: absolute !important;
    height: calc(100% - 1.8rem) !important;
    z-index: 1;
    right: 0;
    top: 1.9rem;
    width: 1.2rem;
  }

  .b-tabs {
    height: 100%;
    margin-right: 1.5rem;

    .tab-content {
      background-color: $secondary;
      border: 1px solid darken($secondary, 10);
      border-top: 0;
      padding: 0.5rem 1rem;
      overflow: auto;
      height: calc(100% - 1.8rem);
    }
  }
  .tabs {
    margin-bottom: 0;

    li {
      margin-right: 0.4rem;
      a {
        background-color: #fff;
        border-bottom: 0;
        padding: 0.2rem 0.5rem;
        span {
          opacity: 0.6;
        }
      }
      &.is-active {
        a {
          background-color: darken($secondary, 50);
          span {
            opacity: 1;
          }
        }
      }
    }
  }

  &__label {
    margin-bottom: 0.8rem;
    textarea {
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SignEditorPanel.vue